export const initialState = {
  loading: [],
};
